import searchStore from '../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Sets the isFocusInSearchInput value in store
 * @param isFocusInSearchInput
 */
export default action('setIsFocusInSearchInput')(function setIsFocusInSearchInput(isFocusInSearchInput) {
    searchStore.isFocusInSearchInput = isFocusInSearchInput;
});
//# sourceMappingURL=setIsFocusInSearchInput.js.map